export default __webpack_public_path__ + "assets/sao-camilo-component.e327e82b.svg";